import { makeVar } from '@apollo/client';

export const lastModifiedQuotationVar = makeVar(null);

export const customQuotationModalOpenVar = makeVar(false);

export const editingQuotationIdVar = makeVar(null);

export const allowAddQuotationsVar = makeVar(false);

export const allowQuotationLockVar = makeVar(false);

export const hasHistoryVar = makeVar(false);

export const headerDataVar = makeVar(null);

export const currentOfferStateCodeVar = makeVar(null);

export const offerInNegotiationStateVar = makeVar(null);
